import { hideAlert, showAlertLong } from '@ui/alert/alert-service.client';
import { useEffect, useRef } from 'react';

export const useInternetConnectionAlert = () => {
  const alertId = useRef<string | null>(null);

  useEffect(() => {
    const handleNetworkChange = () => {
      if (navigator.onLine) {
        if (alertId.current) {
          hideAlert({ id: alertId.current || '' });
        }
      } else if (!alertId.current) {
        alertId.current = showAlertLong({
          message: 'Internet Connection Lost',
          description: 'It looks like you are offline. Please check your network connection.',
          type: 'error',
        });
      }
    };

    const handleOnline = () => {
      if (alertId.current) {
        hideAlert({ id: alertId.current || '' });
        alertId.current = null;
      }
    };

    const handleOffline = () => {
      if (!alertId.current) {
        alertId.current = showAlertLong({
          message: 'Internet Connection Lost',
          description: 'It looks like you are offline. Please check your network connection.',
          type: 'error',
        });
      }
    };

    if ('connection' in navigator) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (navigator.connection as any).addEventListener('change', handleNetworkChange);
      } catch {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        console.warn('navigator.connection not supported');
      }
    } else {
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if ('connection' in navigator) {
        try {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (navigator.connection as any).removeEventListener('change', handleNetworkChange);
        } catch {
          console.warn('navigator.connection not supported');
        }
      }
    };
  }, []);
};
